// extracted by mini-css-extract-plugin
export default {"recommendedText":"v_VioR","revealing":"ffShS0","hatFadeIn":"B9N0YT","currentProductText":"rLA2Jw","saleText":"o8tg5E"};